import React, { FC } from 'react';

export const CommingSoon: FC = () => {
    return (
        <div className="absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
            <h1 className="text-white text-center">
                Chúng tôi đang hoàn thiện tính năng này !
            </h1>
        </div>
    );
};
